var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66669 6.9334C6.07759 6.9334 5.60002 7.41096 5.60002 8.00006V26.6667C5.60002 27.2558 6.07759 27.7334 6.66669 27.7334H25.3334C25.9225 27.7334 26.4 27.2558 26.4 26.6667V8.00006C26.4 7.41096 25.9225 6.9334 25.3334 6.9334H6.66669ZM3.40002 8.00006C3.40002 5.64365 4.31028 4.7334 6.66669 4.7334H25.3334C27.6898 4.7334 28.6 5.64365 28.6 8.00006V26.6667C28.6 29.0231 27.6898 29.9334 25.3334 29.9334H6.66669C4.31028 29.9334 3.40002 29.0231 3.40002 26.6667V8.00006Z",
    fill: "#777D7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 2C22.3284 2 23 2.58763 23 3.3125V7.6875C23 8.41237 22.3284 9 21.5 9C20.6716 9 20 8.41237 20 7.6875V3.3125C20 2.58763 20.6716 2 21.5 2Z",
    fill: "#777D7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2C11.3284 2 12 2.58763 12 3.3125V7.6875C12 8.41237 11.3284 9 10.5 9C9.67157 9 9 8.41237 9 7.6875V3.3125C9 2.58763 9.67157 2 10.5 2Z",
    fill: "#777D7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 13C4 12.4477 4.63207 12 5.41176 12H26.5882C27.3679 12 28 12.4477 28 13C28 13.5523 27.3679 14 26.5882 14H5.41176C4.63207 14 4 13.5523 4 13Z",
    fill: "#777D7C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabCalendar);
export default __webpack_public_path__ + "static/media/tab-calendar.7068e52e25715657ca901b1c25acdd97.svg";
export { ForwardRef as ReactComponent };